import { useQuery } from '@tanstack/react-query';

import bundlesService from '~/services/cruises/BundlesService';

import { bundleQueryKeys } from './bundleQueryKeys';

export function useGetBundleItemOptions(bundleId: string, bundleItemId: string) {
  return useQuery({
    queryKey: bundleQueryKeys.options(bundleId, bundleItemId),
    queryFn: async () => {
      const response = await bundlesService.getOptions(bundleId, bundleItemId);
      return response.result;
    },
    enabled: !!bundleId && !!bundleItemId,
  });
}
